import { TabGroup } from './TabGroup';

export type { TypeTabGroupProps } from './types';
export default TabGroup;
